import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { NetworkListIdCell } from './network-list-id.cell';
import { NetworkListIdHeader } from './network-list-id.header';

export const NetworkListIdColumn: IdentifiedColumnDef<
  GatewayNetworkModel,
  GatewayNetworkModel['id']
> = {
  enableSorting: false,
  header: NetworkListIdHeader,
  cell: NetworkListIdCell,
};
